<div fxLayout="row" fxLayoutAlign="start center">
    <input [disabled]="disabled || lock" [(ngModel)]="value" [type]="type" [placeholder]="placeholder">
    <div *ngIf="!disabled; else removeBlock" (click)="apply()" fxLayout="column" fxLayoutAlign="center center" class="button">
        <ng-container i18n="@@inputWithButton.apply">應用</ng-container>
    </div>
    <ng-template #removeBlock>
        <div (click)="remove()" fxLayout="column" fxLayoutAlign="center center" class="button">
            <ng-container i18n="@@inputWithButton.remove">移除</ng-container>
        </div>
    </ng-template>
    
</div>